/**
 * Integration configuration for third-party services.
 *
 * Logos are stored in /public/images/integrations/.
 * Add new PNG/SVG files there and reference them here.
 */

export interface IntegrationOption {
  id: string;
  label: string;
  description: string;
  logo: string;
  comingSoon?: boolean;
  requiredPlan?: 'STARTER' | 'PREMIUM';
}

export const INTEGRATIONS: Record<string, IntegrationOption> = {
  iyk: {
    id: 'iyk',
    label: 'IYK NFC Chips',
    description: 'NFC chip management for scavenger hunts',
    logo: '/images/integrations/iyk.png',
  },
  mailchimp: {
    id: 'mailchimp',
    label: 'Mailchimp',
    description: 'Automatically add participants to a Mailchimp audience',
    logo: '/images/integrations/mailchimp.png',
    requiredPlan: 'PREMIUM',
  },
  meetup: {
    id: 'meetup',
    label: 'Meetup',
    description: 'Sync events and attendees from Meetup',
    logo: '/images/integrations/meetup.png',
    requiredPlan: 'PREMIUM',
  },
  luma: {
    id: 'luma',
    label: 'Luma',
    description: 'Import events and guests from Luma',
    logo: '/images/integrations/luma.png',
    requiredPlan: 'PREMIUM',
  },
};
